import { HRSectionProps } from './HRSection.types';
import { Container } from './HRSection.styles';

export const HRSection: React.FC<any> = ({ ...otherProps }: React.PropsWithChildren<HRSectionProps>) => {
  return <Container {...otherProps}></Container>;
};
